import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { SeguroStore } from "@interfaces/seguro-store.interface";
import { Store } from "@services/store.service";
import { PageError } from "./page-error.interface";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.css"],
})
export class ErrorComponent implements OnInit {
  public statusCode = 400;
  public mensaje = "por favor intentalo más tarde";
  public titulo = "No se encuentra la página";
  public descripcionError = "La página que buscas no existe";

  tieneConvenio = false;

  constructor(
    private store: Store<SeguroStore>,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.obtenerParametrosError();
    this.verificarConvenio();
  }

  private verificarConvenio(): void {
    const state = this.store.getState();
    /*  if (state.idConvenio) {
      this.tieneConvenio = true;
    } */
  }

  redireccionar(): void {
    this.tieneConvenio
      ? this.router.navigateByUrl("/")
      : (location.href = "https://www.zenitseguros.cl/");
  }

  obtenerParametrosError(): void {
    const state = this.location.getState() as PageError;
    if (state && state.title) {
      this.statusCode = 500;
      this.mensaje = state.subtitle;
      this.titulo = state.title;
      this.descripcionError = state.subDescription;
    }
  }
}
